/* eslint-disable no-use-before-define,no-mixed-operators */
import React from 'react'
import { getBrand, getConfig} from '../twd'
import FramedIn from './framed-in'

export default () => {

    let url = getUrl()
    if (!url) return null

    return <FramedIn
        id='framed-bond-ladder-builder'
        dataName="bond-ladder-builder-frame"
        src={url}
        height={700}
        getHeight={function(w) {
            var h = 0
            try {
                var app = w.Ext.apps.OneStepLadder
                for (var n in app) {
                    var p = app[n]
                    if (typeof p !== 'object') continue

                    try {
                        var m = {
                            criteriapanel: 50,
                            resultspanel: 150,
                        }[n] || 50
                        var a = p.getEl().getHeight() + m
                        h = Math.max(h, a)
                    } catch(e) {}
                }
            } catch(e) {}

            return h
        }}
    />
}


export let getUrl = () => {
    try {
        let base = getConfig('bw_service_host') + '/' + getBrand()
        return `${base}/servlet/deploy/OneStepLadder.htm?theme=etrade&prior=Y`
    } catch(x) {
    }
}